// Clubs
import "./app/clubs/applications/new.coffee";
import "./app/clubs/clubs_form.js.coffee";
import "./app/clubs/index.js.coffee";
import "./app/clubs/orientation.js.coffee";
import "./app/clubs/prepare.coffee";
import "./app/clubs/resources.js.coffee";

// Components
import "./app/components/banner.coffee";
import "./app/components/cardlist.coffee";
import "./app/components/copy_to_clipboard.coffee";
import "./app/components/feedback.coffee";
import "./app/components/loading_indicator.js.coffee";
import "./app/components/mobilenav.coffee";
import "./app/components/photogrid.coffee";
import "./app/components/searchbar.coffee";
import "./app/components/subnavbar.coffee";
import "./app/components/tabsbox.coffee";
import "./app/components/teded_checkmarklist.coffee";
import "./app/components/teded_dropdown.coffee";
import "./app/components/teded_filter.coffee";
import "./app/components/teded_lessons_grid.coffee";
import "./app/components/teded_modal.coffee";
import "./app/components/teded_navbar.coffee";
import "./app/components/teded_notification.coffee";
import "./app/components/temp_user_timer.js.coffee";
import "./app/components/todos_list.coffee";
import "./app/components/toggle.coffee";
import "./app/components/user_controls.coffee";
import "./app/components/video_colorswatch.coffee";
import "./app/components/video_grid.js.coffee";
import "./app/components/video_lazyload.coffee";
import "./app/components/video_preview.js.coffee";
import "./app/components/video_search_loading.js.coffee";
import "./app/components/video_search_pagination.js.coffee";
import "./app/components/video_search_steps.js.coffee";
import "./app/components/video_search.js.coffee";
import "./app/components/youtube_video_seek_to.js.coffee";

// header
import "./app/header/notifications.js.coffee";

// Pages
import "./app/pages/ad_boxes/index.coffee.erb";
import "./app/pages/users/additional_information.coffee";
import "./app/pages/users/settings.coffee";
import "./app/pages/videos/index.js.coffee";
import "./app/pages/get_involved.coffee";
import "./app/pages/patrons.coffee";

// plugins have been moved to javascripts/packs/application.js

import "./app/shared/script.js.erb";

// _base.js.coffee is intentionally excluded
// App and @App are shimmed in config/webpack/enviornment.js

import "./app/charts.js.coffee";
import "./app/search/search-results.js.coffee";
import "./app/share.js.coffee";
import "./app/yt_player_with_ga_tracking.coffee";
